import React, { useEffect } from "react";
import MaterialTable from 'material-table';

// reactstrap components
import { Button, Card, CardBody, Row, Col, Container } from "reactstrap";

// style
import { table_translate } from "../../../constants/MaterialTable.js";

// services
import { showMessage } from "../../../services/message.js";
import { api_POST } from "../../../services/api_service.js";

//Context
import { useAuth } from "../../../context/auth";

export default function ListaVeiculosExclusao({ item, protocolo, handleProximoStep }) {
    const {setLoading} = useAuth();


    const [registro, set_registro] = React.useState(null);

    const [veiculos, set_veiculos] = React.useState([]);
    const [veiculosExcluir, setVeiculosExcluir] = React.useState([]);

    const loadItemRequerimento = () => {
        set_registro(item);
        if (protocolo != null && protocolo.protocoloTransportador[0].protocoloTransportadorVeiculo != null) {
            set_veiculos(protocolo.protocoloTransportador[0].protocoloTransportadorVeiculo);
        }
        if (item != null && item.requerimentoTransportadorVeiculo != null) {
            setVeiculosExcluir(item.requerimentoTransportadorVeiculo);
        }
    }

    useEffect(() => {
        loadItemRequerimento();
    }, [protocolo]);

    const handleAvancar = () => {
        if (veiculosExcluir.length > 1 && item?.setupSolicitacaoAcao?.setupSolicitacao?.categoria?.sigla == "RGG" && item?.setupSolicitacaoAcao?.acao == "Exclusão") {
            showMessage("Aviso", "Selecione apenas um veículo para excluir!", 'warning', null);
            return;
        }

        if (veiculosExcluir.length == 0) {
            showMessage("Aviso", "Selecione os veículos que deseja excluir!", 'error', null);
            return;
        }

        let json_submit = [];
        veiculosExcluir.map(m => {
            json_submit.push(m.protocoloTransportadorVeiculo_Id);
        })

        setLoading(true);
        api_POST(`requerimentoTransportador/PostRequerimentoTransportadorExclusaoVeiculo/${registro.requerimento_Id}`, json_submit)
            .then(result => handleProximoStep(registro))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    return (
        <>
            <div>

                <Card className="card-stats">
                    <CardBody>
                        <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                            <h2 className="titulo-solicitacao">Veículos</h2>
                            <div className="formPrincipal">
                                <Row>
                                    <Col md="12">
                                        <MaterialTable style={{ minHeight: "auto" }}
                                            title=""
                                            columns={[
                                                { title: 'Placa', field: 'placa' },
                                                { title: 'Marca', field: 'marca' },
                                                { title: 'Ano', field: 'anoFabricacao' },
                                                { title: 'Tipo', field: 'tipo' },
                                                { title: 'Tara', field: 'tara' },
                                                { title: 'Renavam', field: 'numeroRenavam' },
                                                { title: 'Status', field: 'status' },
                                                { title: 'Volume', field: 'volume' }
                                            ]}
                                            data={veiculos}
                                            isLoading={false}
                                            options={{
                                                selection: true
                                            }}
                                            onSelectionChange={(rows) => setVeiculosExcluir(rows)}
                                            localization={table_translate}
                                        />
                                    </Col>
                                    <Col lg="6" className="text-left">
                                    </Col>
                                    <Col lg="6" className="text-right">
                                        {handleProximoStep != null &&
                                            <Button color="success" onClick={handleAvancar} className="btn-mobile" type="button">Próxima Etapa  <i className="fas fa-chevron-right"></i></Button>
                                        }
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}           